export default function Privacy() {
  return (
    <div className="page-container">
      <div className="legal-section-container">
        <div className="support-content">
          <h2>Privacy Policy</h2>
          <p><strong>AirMouse values your privacy. We want to make it clear that:</strong></p>

          <h3>No Data Collection</h3>
          <p>AirMouse does not collect, store, or share any personal information.</p>
          <p>The app does not access the public Internet. It only communicates over your local network to connect your mobile device with your computer.</p>

          <h3>No Tracking or Analytics</h3>
          <p>AirMouse does not use cookies, analytics, advertising, or tracking tools of any kind.</p>

          <h3>No Third-Party Sharing</h3>
          <p>Since no information is collected, no information is ever shared with third parties.</p>

          <h3>Local Network Only</h3>
          <p>All interactions between your mobile device and your computer remain on your local network. No data is transmitted to us or stored on external servers.</p>

          <h3>Children’s Privacy</h3>
          <p>Since no data is collected, AirMouse is safe for all ages.</p>

          <h3>Contact Us</h3>
          <p>
            If you have questions about this Privacy Policy, you can reach us at:
            <a href="mailto:airmouse.help@gmail.com" className="legal-email-link"> airmouse.help@gmail.com</a>
          </p>
        </div>
      </div>

      <div className="support-container">
        <div className="support-content">
          <h2>Need More Help?</h2>
          <p>If you have additional questions or need further assistance, our support team is here to help.</p>
          <div className="support-email">
            <span className="email-label">Contact us at:</span>
            <a href="mailto:airmouse.help@gmail.com" className="support-email-link">
              airmouse.help@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

